import { render } from "./EditPageForm.vue?vue&type=template&id=0e9e80d6"
import script from "./EditPageForm.vue?vue&type=script&lang=js"
export * from "./EditPageForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__